module.exports = __webpack_public_path__ + "static/media/Pong.e0e0eafb.png";